// import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '../material/material.module';
import { environment } from './../../../environments/environment';
import { AddressInputComponent } from './components/address-input/address-input.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { RidersDialogComponent } from './components/dialog/riders-dialog/riders-dialog.component';
import { IosBannerPwaComponent } from './components/ios-banner-pwa/ios-banner-pwa.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { CurrencyLocalPipe } from './pipes/currency-local.pipe';
import { TenantsListComponent } from './tenants-list/tenants-list.component';
import { TenantsFiltersComponent } from './tenants-filters/tenants-filters.component';
import { CouponsFiltersComponent } from './coupons-filters/coupons-filters.component';
import { CouponsListComponent } from './coupons-list/coupons-list.component';
import { UsersListComponent } from './users-list/users-list.component';
import { UsersFiltersComponent } from './users-filters/users-filters.component';
import { ProductsListComponent } from './products-list/products-list.component';
import { ProductsFiltersComponent } from './products-filters/products-filters.component';
import { IngredientsListComponent } from './ingredients-list/ingredients-list.component';
import { IngredientsFiltersComponent } from './ingredients-filters/ingredients-filters.component';
import { TimeSlotsFilterComponent } from './time-slots-filters/time-slots-filters.component';
import { TimeSlotsListComponent } from './time-slots-list/time-slots-list.component';
import { ClosuresFiltersComponent } from './closures-filters/closures-filters.component';
import { ClosuresListComponent } from './closures-list/closures-list.component';
import { RidersListComponent } from './riders-list/riders-list.component';
import { RidersFiltersComponent } from './riders-filters/riders-filters.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { CustomersFiltersComponent } from './customers-filters/customers-filters.component';
import { ZonesListComponent } from './zones-list/zones-list.component';
import { ZonesFiltersComponent} from './zones-filters/zones-filters.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { PopupsListComponent } from './popups-list/popups-list.component';
import { PopupsFiltersComponent } from './popups-filters/popups-filters.component';
import { NotificationsListComponent } from './notifications-list/notifications-list.component';
import { NotificationsFiltersComponent } from './notifications-filters/notifications-filters.component';

// Components
@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MaterialModule,
    RouterModule,

    // AgmCoreModule.forRoot({
    //   apiKey: environment.gMapsApiKey,
    //   libraries: ["places"]
    // })
  ],
  exports: [
    NotFoundComponent,
    SpinnerComponent,
    AddressInputComponent,
    CurrencyLocalPipe,
    IosBannerPwaComponent,
    ReactiveFormsModule,
    TenantsListComponent,
    TenantsFiltersComponent,
    UsersFiltersComponent,
    CouponsFiltersComponent,
    ProductsFiltersComponent,
    CouponsListComponent,
    IngredientsListComponent,
    IngredientsFiltersComponent,
    UsersListComponent,
    ProductsListComponent,
    TimeSlotsFilterComponent,
    TimeSlotsListComponent,
    ClosuresFiltersComponent,
    ClosuresListComponent,
    RidersListComponent,
    RidersFiltersComponent,
    CustomerListComponent,
    CustomersFiltersComponent,
    ZonesListComponent,
    ZonesFiltersComponent,
    ConfirmDialogComponent,
    PopupsListComponent,
    PopupsFiltersComponent,
    NotificationsListComponent,
    NotificationsFiltersComponent
  ],
  declarations: [
    NotFoundComponent,
    SpinnerComponent,
    DialogComponent,
    RidersDialogComponent,
    AddressInputComponent,
    CurrencyLocalPipe,
    IosBannerPwaComponent,
    TenantsListComponent,
    TenantsFiltersComponent,
    UsersFiltersComponent,
    CouponsFiltersComponent,
    ProductsFiltersComponent,
    CouponsListComponent,
    IngredientsListComponent,
    IngredientsFiltersComponent,
    UsersListComponent,
    ProductsListComponent,
    TimeSlotsFilterComponent,
    TimeSlotsListComponent,
    ClosuresFiltersComponent,
    ClosuresListComponent,
    RidersListComponent,
    RidersFiltersComponent,
    CustomerListComponent,
    CustomersFiltersComponent,
    ZonesListComponent,
    ZonesFiltersComponent,
    ConfirmDialogComponent,
    PopupsListComponent,
    PopupsFiltersComponent,
    NotificationsListComponent,
    NotificationsFiltersComponent
  ]
})
export class SharedModule { }
